module.exports = __webpack_public_path__ + "static/media/0025.3d2a0d11.svg";